import Avataaars from './Avataaars.vue'

export default Avataaars
